"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Language = function Language(api, data) {
  (0, _classCallCheck3.default)(this, Language);

  Object.assign(this, (0, _extends3.default)({ api: api }, data));
};

Language._namespace = "languages";

Language.getLanguages = function (api) {
  return api.getCollection(Language, "languages");
};

Language.addNewLanguage = function (api, data) {
  return api.postObject(Language, "languages", data);
};

Language.updateLanguage = function (api, id, data) {
  return api.putObject(Language, "language", id, data);
};

Language.deleteLanguage = function (api, id) {
  return api.deleteObject(Language, "languages", id);
};

exports.default = Language;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Language.js
// module id = 312
// module chunks = 0